import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { cardsStore } from '../../store/cardsStore';
import { CARDS_TYPE } from '../../enums/cardTypes';

export const CurrentBoxCards = observer(({ currentBoxIndex }) => {
  const { boxCards, selectedCardType } = cardsStore;

  const cards = useMemo(() => {
    return boxCards.filter(({ boxIndex }) => boxIndex === currentBoxIndex);
  }, [boxCards, currentBoxIndex]);

  return (
    <>
      {cards.map(({ card, index }) => (
        <div
          key={index}
          className={`bet-on-poker-seat-card ${selectedCardType} ${CARDS_TYPE[card]}`}
        />
      ))}
    </>
  );
});
